export const DISABLE_ARE_YOU_STILL_WATCHING = 'DISABLE_ARE_YOU_STILL_WATCHING' as const;
export const SHOW_ARE_YOU_STILL_WATCHING = 'SHOW_ARE_YOU_STILL_WATCHING' as const;
export const HIDE_ARE_YOU_STILL_WATCHING = 'HIDE_ARE_YOU_STILL_WATCHING' as const;

export const disableAreYouStillWatching = () => {
  return {
    type: DISABLE_ARE_YOU_STILL_WATCHING,
  };
};

export const showAreYouStillWatching = () => {
  return {
    type: SHOW_ARE_YOU_STILL_WATCHING,
  };
};

export const hideAreYouStillWatching = () => {
  return {
    type: HIDE_ARE_YOU_STILL_WATCHING,
  };
};
